import React from "react";
import _ from "lodash";
import numeral from "numeral";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

class PrebidRequestView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      columns: [],
      groups: [],
      amount: null,

      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      tags: [],
      alias: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns, dataList } = this.props;

    const [additionData] = dataList;

    const parsedCol = [
      ...columns.map((d) => {
        if (d.includes("-1")) {
          return d.replace("-1", "nopb");
        } else if (d.includes("-3")) {
          return d.replace("-3", "pb");
        }
        return d;
      }),
      "billing_key_tagged_request",
    ];

    const pbKeyCol = parsedCol.filter((d) => {
      if (
        [
          "ext_gam_unit_id",
          "date",
          "upa_nopb_request_v2",
          "upa_o_nopb_request_v2",
          "upa_pb_request_v2",
          "upa_o_pb_request_v2",
        ].includes(d)
      ) {
        return false;
      }
      return d.includes("_request_v2");
    });

    const keyMap = new Map();

    const idIndex = _.indexOf(additionData.columns, "ext_gam_unit_id");
    const dateIndex = _.indexOf(additionData.columns, "date");
    const targetIndex = _.indexOf(
      additionData.columns,
      "billing_key_tagged_request"
    );

    additionData.records.forEach((item) => {
      const id = item[idIndex];
      const date = item[dateIndex];
      keyMap.set(`${id}-${date}`, item[targetIndex] || 0);
    });

    const recIdIndex = _.indexOf(columns, "ext_gam_unit_id");
    const recDateIndex = _.indexOf(columns, "date");

    const newRecords = records.map((item) => {
      const id = item[recIdIndex];
      const date = item[recDateIndex];

      return [...item, keyMap.get(`${id}-${date}`) || 0];
    });

    const arrangeCol = [
      {
        key: "ext_gam_unit_id",
        label: "Ext Gam Unit Id",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "upa_nopb_request_v2",
        label: "nopb req #",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "upa_o_nopb_request_v2",
        label: "o nopb req #",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "upa_pb_request_v2",
        label: "pb req #",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "upa_o_pb_request_v2",
        label: "o pb req #",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "billing_key_tagged_request",
        label: "bk tag req #",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
      },
      ...pbKeyCol.map((key) => ({
        key,
        label: `${key.replace("_request_v2", "")} req #`,
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      })),
      {
        key: "upa_coverage",
        label: "upa coverage %",
        parsefunc: ({
          upa_nopb_request_v2,
          upa_pb_request_v2,
          billing_key_tagged_request,
        }) => {
          return billing_key_tagged_request === 0
            ? 0
            : ((upa_nopb_request_v2 + upa_pb_request_v2) /
                billing_key_tagged_request) *
                100;
        },
        format: (val) => {
          return `${numeral(val).format("0.00")}%`;
        },
        align: "text-right",
      },
      {
        key: "opt_pb_ratio",
        label: "opt pb ratio %",
        parsefunc: ({ upa_o_pb_request_v2, upa_pb_request_v2 }) => {
          return upa_pb_request_v2 === 0
            ? 0
            : (upa_o_pb_request_v2 / upa_pb_request_v2) * 100;
        },
        format: (val) => {
          return `${numeral(val).format("0.00")}%`;
        },
        align: "text-right",
      },
      {
        key: "opt_no_pb_ratio",
        label: "opt no pb ratio %",
        parsefunc: ({ upa_nopb_request_v2, upa_o_nopb_request_v2 }) => {
          return upa_nopb_request_v2 === 0
            ? 0
            : (upa_o_nopb_request_v2 / upa_nopb_request_v2) * 100;
        },
        format: (val) => {
          return `${numeral(val).format("0.00")}%`;
        },
        align: "text-right",
      },
    ];

    const result = parseTableData({
      columns: parsedCol,
      arrangeColumns: arrangeCol,
      records: newRecords,
      mainKey: "ext_gam_unit_id",
      orderKey: "billing_key_tagged_request",
    });

    this.setState({
      ...result,
      filterGroups: result.groups,
      filterRecords: result.records,
      filterAmount: result.amount,
      columns: arrangeCol,
      tags: arrangeCol
        .slice(2)
        .filter((item) => !item.hide)
        .map((item) => ({
          value: item.key,
          label: item.label,
        })),
      alias: [],
    });
  }

  handleSearch(expression) {
    const { records, columns } = this.state;

    const result = filterDataToGroup({
      expression,
      records,
      columns,
    });

    if (result) {
      this.setState({
        ...result,
      });
    }
  }

  render() {
    const { columns, tags, filterAmount, filterGroups, filterRecords, alias } =
      this.state;

    return (
      <>
        <div className="mb-2">
          <FilterControl
            tags={tags}
            alias={alias}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>

        <div className="w-full overflow-x-auto">
          <GroupDataTable
            records={filterRecords}
            groups={filterGroups}
            amount={filterAmount}
            mainKey="ext_gam_unit_id"
            columns={columns}
          ></GroupDataTable>
        </div>
      </>
    );
  }
}
export default PrebidRequestView;
